import { memo } from 'react';

type SvgProps = React.ComponentPropsWithoutRef<'svg'>;

export const GeometrypadIcon = memo(({ className, ...props }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Triangle */}
      <polygon points="12,3 3,20 21,20" />
    </svg>
  );
});

GeometrypadIcon.displayName = 'GeometrypadIcon';
